import { BannerColorTheme } from '@/types/components';

type BannerThemeClasses = {
  container: string;
  content: string;
  close: string;
};

export const BANNER_THEMES: Record<BannerColorTheme, BannerThemeClasses> = {
  black: {
    container: 'bg-sh-black',
    content: 'text-white!',
    close: 'text-sh-gray',
  },
  teal: {
    container: 'bg-sh-teal',
    content: 'text-sh-black!',
    close: 'text-sh-brown',
  },
  cream: {
    container: 'bg-sh-cream',
    content: 'text-sh-black!',
    close: 'text-sh-brown',
  },
  tan: {
    container: 'bg-sh-tan',
    content: 'text-sh-black!',
    close: 'text-sh-brown',
  },
};

export const DEFAULT_BANNER_THEME: BannerColorTheme = 'black';

export function toBannerColorTheme(value: unknown): BannerColorTheme {
  return typeof value === 'string' && value in BANNER_THEMES
    ? (value as BannerColorTheme)
    : DEFAULT_BANNER_THEME;
}
